module.exports = __webpack_public_path__ + "img/rspca-wa.9a0c03d.png";